import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "@amsaas/api";

/**
 * Typed tRPC React client (ADR-003). `AppRouter` is imported as a TYPE only
 * from the API package — no server code reaches the browser bundle.
 */
export const trpc = createTRPCReact<AppRouter>();
